import { z } from 'zod';
import {
  SubsidyCapType,
  FinanceProgramType,
  FinanceProgramRateType,
  CreditSubmissionDecisionFeeType,
} from '@trnsact/trnsact-shared-types';

import {
  Structures,
  MarkupType,
  MarkupMethods,
  PaymentCalculationMethods,
  CreateProposalFinanceExistingOptions,
} from './types';

export const FinanceStructureSchema = z.object({
  financeQuote: z.object({
    programName: z.string(),
    rateType: z.nativeEnum(FinanceProgramRateType),
    structure: z.nativeEnum(Structures),
    program: z.string().nullable(),

    maxApprovalAmount: z.number().nullable(),

    amount: z.number(),
    markupRate: z.number().nullable(),
    dealerMarkup: z.number().nullable(),
    specifyRatePerTerm: z.number(),

    startDate: z.string(),
    advancePayment: z.string(),
    firstPaymentDate: z.string(),
    daysToFirstPayment: z.string(),
    residual: z.number().nullable(),
    programType: z.nativeEnum(FinanceProgramType),

    menu: z.string().uuid().nullable(),
    specifyRates: z.array(
      z.object({
        term: z.string(),
        rate: z.number(),
      })
    ),
    commonRate: z.number(),
    specifyRate: z.boolean(),
    terms: z.array(z.string()),
    minimumRequiredDownPayment: z.number(),
    customTermTemporaryValue: z.string().nullable(),
    selectedSubmissionId: z.string().uuid().nullable(),
    paymentCalculationMethod: z.nativeEnum(PaymentCalculationMethods),
    createProposalWithExistingProgram: z.nativeEnum(CreateProposalFinanceExistingOptions).nullable(),

    specifyLenderMarketRates: z.array(z.object({ term: z.string(), rate: z.number() })),

    configureSubsidyCap: z.boolean(),

    markupMethod: z.nativeEnum(MarkupMethods).optional(),
    subsidyType: z.nativeEnum(MarkupType).optional(),

    commonLenderMarketRate: z.number(),

    subsidyCapConfiguration: z
      .object({
        lenderName: z.string().optional(),
        maxSubsidyAmount: z.number().optional(),
        netInvoiceAmount: z.number().optional(),
        netInvoicePercentage: z.number().optional(),
        subsidyCapType: z.nativeEnum(SubsidyCapType).optional(),
        lenderMarketRates: z.array(z.object({ term: z.number(), rate: z.number() })).optional(),
      })
      .optional(),

    fee: z.array(
      z.object({
        fee: z.number(),
        financed: z.boolean(),
        identifier: z.string(),
        type: z.nativeEnum(CreditSubmissionDecisionFeeType),
      })
    ),
  }),
});
